import React, {Component} from 'react';
import get from 'lodash/get';
import {constants} from '@neosvoc/nv-platform-core-common';
import StringLogic from './logic/StringLogic';
import ChoiceLogic from './logic/ChoiceLogic';
import MultipleChoiceLogic from './logic/MultipleChoiceLogic';
import DateLogic from './logic/DateLogic';
import BatteryLogic from './logic/BatteryLogic';
import BatteryMultipleLogic from './logic/BatteryMultipleLogic';
import NumberLogic from './logic/NumberLogic';
import MultipleNumberLogic from './logic/MultipleNumberLogic';
import MultipleNumber3Logic from './logic/MultipleNumber3Logic';
import RankLogic from './logic/RankLogic';
import ParameterLogic from './logic/ParameterLogic';
import conditionBuilders from '../../../services/conditionBuilders';
import {stripHtml} from '../../../utils/text';

const multipleNumber1Label = (item) => `${item.minLabel}-${item.maxLabel}`;
const multipleNumber2Label = (item) => stripHtml(item.label);

export class Expression extends Component {
    render() {
        const {form, field, items, extraFields, parameters} = this.props;
        const expression = get(form.values, field.name);
        const item = items.find((i) => i.id == expression.id);
        if (!item) {
            const param = parameters && parameters.find((p) => `parameters.${p.name}` === expression.id);
            if (param) {
                return <ParameterLogic {...this.props} condition={conditionBuilders[constants.EDITOR_VARIABLES.PARAMETERS]()} item={param} />;
            }
            const extraField = extraFields && extraFields.find((f) => `extraFields.${f.name}` === expression.id);
            if (extraField) {
                return <ParameterLogic {...this.props} condition={conditionBuilders[constants.EDITOR_VARIABLES.EXTRA_FIELDS]()} item={extraField} />;
            }
            return null;
        }

        if (!conditionBuilders[item.type]) {
            throw new Error(`Cannot find condition builder for type "${item.type}"`);
        }

        const condition = conditionBuilders[item.type]();

        switch (item.type) {
            case constants.EDITOR_TEMPLATES.STRING_1:
                return <StringLogic {...this.props} condition={condition} item={item} />;
            case constants.EDITOR_TEMPLATES.SINGLE_CHOICE_1:
            case constants.EDITOR_TEMPLATES.SINGLE_CHOICE_2:
            case constants.EDITOR_TEMPLATES.SINGLE_CHOICE_3:
            case constants.EDITOR_TEMPLATES.SINGLE_CHOICE_4:
            case constants.EDITOR_TEMPLATES.GENERATOR_CLASSIFIER_2:
                return <ChoiceLogic {...this.props} condition={condition} item={item} />;
            case constants.EDITOR_TEMPLATES.MULTIPLE_CHOICE_1:
            case constants.EDITOR_TEMPLATES.MULTIPLE_CHOICE_2:
                return <MultipleChoiceLogic {...this.props} condition={condition} item={item} />;
            case constants.EDITOR_TEMPLATES.DATE_1:
                return <DateLogic {...this.props} condition={condition} item={item} />;
            case constants.EDITOR_TEMPLATES.BATTERY_1:
                return <BatteryLogic {...this.props} condition={condition} item={item} />;
            case constants.EDITOR_TEMPLATES.BATTERY_2:
                return <BatteryMultipleLogic {...this.props} condition={condition} item={item} />;
            case constants.EDITOR_TEMPLATES.NUMBER_1:
            case constants.EDITOR_TEMPLATES.NUMBER_2:
                return <NumberLogic {...this.props} condition={condition} item={item} />;
            case constants.EDITOR_TEMPLATES.MULTIPLE_NUMBER_1:
                return <MultipleNumberLogic {...this.props} condition={condition} item={item} label={multipleNumber1Label} />;
            case constants.EDITOR_TEMPLATES.MULTIPLE_NUMBER_2:
                return <MultipleNumberLogic {...this.props} condition={condition} item={item} label={multipleNumber2Label} />;
            case constants.EDITOR_TEMPLATES.MULTIPLE_NUMBER_3:
                return <MultipleNumber3Logic {...this.props} condition={condition} item={item} label={multipleNumber2Label} />;
            case constants.EDITOR_TEMPLATES.RANK_1:
                return <RankLogic {...this.props} condition={condition} item={item} />;
            default:
                throw new Error(`Cannot find logic for type "${item.type}".`);
        }
    }
}

export default Expression;
